import React, { useMemo } from 'react';
import { ButtonProps, FormItemProps } from 'antd';

import { ButtonStyle } from './styled';

type Props = {
  content: string | React.ReactNode;
  type?: 'primary' | 'secondary' | 'default';
  disabled?: boolean;
  buttonProps?: ButtonProps;
  className?: string;
  isLoading?: boolean;
  icon?: React.ReactNode;
  color?: string;
  onClick?: () => void;
} & Omit<FormItemProps, 'children'>;

const ButtonField: React.FC<Props> = ({
  content,
  buttonProps,
  className,
  type,
  disabled,
  isLoading,
  icon,
  color,
  onClick,
}) => {
  const setColor = useMemo(() => {
    switch (type) {
      case 'primary':
        return '#3699FF';
      case 'secondary':
        return '#F64E60';
      case 'default':
        return '#2C2F36';
      default:
        return '#F64E60';
    }
  }, [type]);

  return (
    <ButtonStyle
      color={setColor}
      loading={isLoading}
      disabled={disabled}
      onClick={onClick}
      icon={icon}
      className={`${className ?? ''}`}
      {...buttonProps}
    >
      {content}
    </ButtonStyle>
  );
};

export default ButtonField;
